// extracted by mini-css-extract-plugin
export default {"container":"UserDetails__container--2O7","title":"UserDetails__title--1Hz","error":"UserDetails__error--1O7","text":"UserDetails__text--1Al","button":"UserDetails__button--2Uk"};